module.exports = __webpack_public_path__ + "img/Logo.b116e4a8.svg";